export default __webpack_public_path__ + "static/mobile_8-e1c4c4262c72018e447ccd266d71eb3b.webp";